import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import onClickHandlerForNonInteractiveElements from '@elliemae/ds-utilities/onClickHandlerForNonInteractiveElements';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import DSTooltip from '@elliemae/ds-tooltip';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DSToggleRender = function DSToggleRender(_ref) {
  var containerProps = _ref.containerProps,
      id = _ref.id,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      hide = _ref.hide,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return null;
  } : _ref$onFocus,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {
    return null;
  } : _ref$onMouseDown,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {
    return null;
  } : _ref$onMouseEnter,
      _ref$onMouseLeave = _ref.onMouseLeave,
      onMouseLeave = _ref$onMouseLeave === void 0 ? function () {
    return null;
  } : _ref$onMouseLeave,
      _ref$onTouchCancel = _ref.onTouchCancel,
      onTouchCancel = _ref$onTouchCancel === void 0 ? function () {
    return null;
  } : _ref$onTouchCancel,
      _ref$onTouchEnd = _ref.onTouchEnd,
      onTouchEnd = _ref$onTouchEnd === void 0 ? function () {
    return null;
  } : _ref$onTouchEnd,
      _ref$onTouchMove = _ref.onTouchMove,
      onTouchMove = _ref$onTouchMove === void 0 ? function () {
    return null;
  } : _ref$onTouchMove,
      _ref$onTouchStart = _ref.onTouchStart,
      onTouchStart = _ref$onTouchStart === void 0 ? function () {
    return null;
  } : _ref$onTouchStart,
      _ref$labelOn = _ref.labelOn,
      labelOn = _ref$labelOn === void 0 ? 'ON' : _ref$labelOn,
      _ref$labelOff = _ref.labelOff,
      labelOff = _ref$labelOff === void 0 ? 'OFF' : _ref$labelOff,
      _ref$dragStyle = _ref.dragStyle,
      dragStyle = _ref$dragStyle === void 0 ? {} : _ref$dragStyle,
      _ref$containerRef = _ref.containerRef,
      containerRef = _ref$containerRef === void 0 ? null : _ref$containerRef,
      _ref$handRef = _ref.handRef,
      handRef = _ref$handRef === void 0 ? null : _ref$handRef,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      defaultState = _ref.defaultState;

  var _convertPropToCssClas = convertPropToCssClassName('form-element-toggle', className, {
    hasError: hasError,
    readOnly: readOnly,
    disabled: disabled,
    checked: checked,
    id: id,
    size: size
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameBlock = _convertPropToCssClas.classNameBlock,
      classNameElement = _convertPropToCssClas.classNameElement;

  var allowChange = disabled || readOnly;
  var label = checked ? /*#__PURE__*/React.createElement("div", {
    className: classNameElement('icon-on')
  }, labelOn) : /*#__PURE__*/React.createElement("div", {
    className: classNameElement('icon-off')
  }, labelOff);

  if (readOnly) {
    label = /*#__PURE__*/React.createElement(DSTooltip, {
      interactionType: "hover",
      title: "Read Only",
      triggerComponent: label
    });
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "em-ds-toggle"
  }, containerProps, {
    "aria-disabled": disabled,
    defaultChecked: checked,
    defaultValue: value
  }, onClickHandlerForNonInteractiveElements(allowChange ? null : onChange), {
    ref: containerRef,
    className: "".concat(cssClassName, " ").concat(defaultState ? 'default-state-checked' : '').concat(hide ? ' ds-form-element-toggle-hide' : ''),
    onBlur: onBlur,
    onFocus: onFocus // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    ,
    "aria-checked": checked,
    role: "checkbox",
    tabIndex: 0
  }), /*#__PURE__*/React.createElement("div", {
    className: classNameBlock('box')
  }, label), /*#__PURE__*/React.createElement("div", {
    ref: handRef,
    "aria-checked": checked,
    "aria-disabled": disabled,
    className: "".concat(classNameElement('input'), " ").concat(defaultState ? 'default-state-checked' : ''),
    onMouseDown: allowChange ? null : onMouseDown,
    onMouseEnter: allowChange ? null : onMouseEnter,
    onMouseLeave: allowChange ? null : onMouseLeave,
    onTouchCancel: allowChange ? null : onTouchCancel,
    onTouchEnd: allowChange ? null : onTouchEnd,
    onTouchMove: allowChange ? null : onTouchMove,
    onTouchStart: allowChange ? null : onTouchStart,
    style: _objectSpread(_objectSpread({}, style), dragStyle)
  }), /*#__PURE__*/React.createElement("input", {
    className: classNameElement('hidden-checkbox'),
    defaultChecked: checked,
    defaultValue: value,
    name: name,
    type: "checkbox"
  }));
};

export default DSToggleRender;
//# sourceMappingURL=DSToggleRender.js.map
